import sites from "@/mixins/admin/requests/sites/sites";

import editorFiles from "@/mixins/admin/requests/editorFiles/editorFiles";

import queue from "@/mixins/admin/requests/queue/getQueueLines";

import visitors from "@/mixins/admin/requests/visitors/visitors";

import sendEvacuationMessageToActiveVisitors
  from "@/mixins/admin/requests/messages/evacuationMessages/sendEvacuationMessageToActiveVisitors";

export default {
  mixins: [
    sites,
    editorFiles,
    queue,
    visitors,
    sendEvacuationMessageToActiveVisitors
  ]
};
